import React, { Component } from "react";
import { getConfigDaily, monthOptions, yearOptions } from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import * as R from "ramda";
import { tabelConfig } from "../../../../crmh23/followup/config";
import { saveAs } from "file-saver";
import { buildExcelRequestBody } from "../configExcel";
import moment from "moment";
class LaporanPartHarian extends Component {
  constructor(props) {
    super(props);
    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();
    this.state = {
      month: null,
      year: null,
      tableConfig: getConfigDaily("MEKANIK", currentMonth, currentYear),
      tableConfigSA: getConfigDaily("SA", currentMonth, currentYear),
      dataTable: [],
      dataTableSA: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  mapPartHarianToTable = (list = []) =>
    list.map((item) => {
      const harian = {};

      Object.keys(item.partHarian || {}).forEach((key) => {
        harian[String(key)] = item.partHarian[key];
      });

      return {
        name: item.name,
        ...harian,
        total: item.total,
        proyeksi: item.proyeksi,
      };
    });

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPartHarianH23,
        setError: this.props.setError,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Part Harian",
        args: {
          kodeCabang: this.props.search.selectedCabang,
          year: this.state.year.value,
          month: this.state.month?.value,
          employeeId: this.props.employeeId,
        },
      });

      if (res?.ok && res.data?.data) {
        const { mekanik = [], sa = [] } = res.data.data;

        this.setState({
          dataTable: this.mapPartHarianToTable(mekanik),
          tableConfig: getConfigDaily(
            "MEKANIK",
            this.state.month?.value,
            this.state.year?.value,
          ),
          dataTableSA: this.mapPartHarianToTable(sa),
          tableConfigSA: getConfigDaily(
            "SA",
            this.state.month?.value,
            this.state.year?.value,
          ),
        });
      }

      this.props.triggerLoading();
    } catch (err) {
      this.props.triggerLoading();
      console.log(err);
    }
  };

  handlePrint = async () => {
    this.props.triggerLoading();

    const { month, year, dataTable, dataTableSA } = this.state;

    const reqBody = buildExcelRequestBody({
      month,
      year: year.value,
      dataTable,
      dataTableSA,
    });

    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Harian Part",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
    }

    this.props.triggerLoading();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>

        <div style={{ marginBottom: 30 }}>
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
            options={{ pagination: false }}
          />
        </div>

        <SimpleDataTable
          data={this.state.dataTableSA}
          columns={this.state.tableConfigSA}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </>
    );
  }
}

export default LaporanPartHarian;
